
import { IGetIndicatorEventsParameters } from "./IGetIndicatorEventsParameters";


export class GetIndicatorEventsParameters implements IGetIndicatorEventsParameters
{
    componentId: number = 0;
    indicatorId: number = 0;
    fromDate: Date = new Date();
    toDate: Date = new Date();
}
